import React, { useState, useEffect } from "react";
import {
  Typography,
  TextField,
  InputAdornment,
  Box,
  Button,
  Autocomplete,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useSnackbar } from "notistack";
import { UseAddOrder } from "./UseAddOrder";
import LanIcon from "@mui/icons-material/Lan";
import { rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";

export default function SearchCom(props) {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { GetProductsByWord } = UseAddOrder();
  const [open, setOpen] = useState(false);
  const [productList, setProductList] = useState([]);
  const [productList1, setProductList1] = useState([]);
  const [searchState, setSearchState] = React.useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [productsByWordRes, setProductsByWordRes] = useState();
  const [productById, setProductById] = useState();

  function submit() {
    if (searchState.length > 0) {
      setProgress(true);
      GetProductsByWord(
        searchState.replace(/^\s+/, ""),
        (productsByWord) => {
          setProgress(false);
          setProductsByWordRes(productsByWord);
        },
        props.boolFactor ? props.boolFactor : false
      );
    } else if (searchState == "") {
      props.setSelectedProduct("");
      setProductList([]);
    }
  }

  const getMembers = (members) => {
    let children = [];
    return members
      .map((m) => {
        if (m.slaveProducts && m.slaveProducts.length) {
          children = [...children, ...m.slaveProducts];
          children.map((child) => {
            child.margin = true;
            return child;
          });
        }
        return m;
      })
      .concat(children.length ? getMembers(children) : children);
  };

  useEffect(() => {
    if (productList1 && productList1.length > 0) {
      let childs = getMembers(productList1);
      setProductList(childs);
    }
  }, [productList1]);

  useEffect(() => {
    if (!props.productID) {
      setSearchState("");
    }
  }, [props.productID, props.productModel]);

  function reset() {
    props.setProductModel("");
    setSearchState("");
    props.setSelectedProduct("");
    setProductList([]);
    setOpen(false);
  }

  useEffect(() => {
    if (productsByWordRes && productsByWordRes.length == 1) {
      GetProductsByWord(productsByWordRes[0].id, (productById) => {
        setProductById(productById[0]);
      });
      setOpen(false);
    } else if (productsByWordRes && productsByWordRes.length > 1) {
      setProductList1(productsByWordRes);
      setOpen(true);
    } else if (
      searchState &&
      productsByWordRes &&
      productsByWordRes.length == 0
    ) {
      enqueueSnackbar("نتیجه ای برای جستجوی شما پیدا نشد", {
        variant: "error",
        autoHideDuration: 2000,
      });
      reset();
    }
  }, [productsByWordRes]);

  useEffect(() => {
    if (productById) {
      props.setSelectedProduct(productById);
      setSearchState(productById.id + "-" + productById.faName);
    }
  }, [productById]);

  useEffect(() => {
    if (props.reload) {
      if (productById) {
        GetProductsByWord(productById.id, (productById) => {
          setProductById(productById[0]);
          props.setReload(false);
        });
      }
    }
  }, [props.reload]);

  return (
    <Box
      sx={{
        width: props.fullwidth ? "100%" : "75%",
      }}
    >
      <Autocomplete
        filterOptions={(options, state) => options}
        onChange={(evt, value) => {
          if (value) {
            props.setProductModel({
              ...props.productModel,
              orderCount: undefined,
            });
            setProductList([]);
            GetProductsByWord(value.id, (productById) => {
              setProductById(productById[0]);
            });
            setOpen(false);
          } else {
            reset();
          }
        }}
        open={open}
        onClose={() => setOpen(false)}
        disableClearable
        clearOnEscape
        inputValue={searchState ? searchState : ""}
        size="small"
        options={productList ? productList.sort((a, b) => a.id - b.id) : ""}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            reset();
          }
        }}
        renderOption={(props, option, { selected }) => {
          return (
            <li {...props}>
              <Typography
                sx={{
                  color: option.margin && "secondary.main",
                  ml: option.margin && 2,
                }}
              >
                {option.id} -
              </Typography>
              {option.margin && (
                <LanIcon sx={{ mr: 1 }} fontSize="small" color="secondary" />
              )}
              <Typography
                sx={{
                  color: option.margin && "secondary.main",
                }}
              >
                {option.faName}
              </Typography>
            </li>
          );
        }}
        sx={{
          "&  .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
            pr: "5px !important",
          },
        }}
        ListboxProps={{ sx: { maxHeight: "50vh" } }}
        getOptionLabel={(option) => (option ? option.faName : "")}
        renderInput={(params) => (
          <TextField
            autoFocus={true}
            {...params}
            variant="outlined"
            sx={{
              px: 0,
              width: "100%",
              "& .MuiOutlinedInput-root": {
                height: "100%",
                pr: 1,
              },
              "&  .MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
                paddingLeft: "1px !important",
              },
              height: "100%",
              input: {
                height: "100%",
              },
            }}
            fullWidth
            autoComplete="off"
            onChange={(evt) => {
              if (evt.target.value) {
                setSearchState(evt.target.value.replace(/ِ/g, "D"));
              } else {
                reset();
              }
            }}
            placeholder="جستجو..."
            InputProps={{
              ...params.InputProps,

              startAdornment: (
                <InputAdornment sx={{ m: 0 }} position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: searchState != "" && (
                <InputAdornment position="end">
                  <Button onClick={() => reset()}>پاک کردن</Button>
                </InputAdornment>
              ),
              onKeyDown: (e) => {
                if (e.key === "Enter" && !open) {
                  e.stopPropagation();
                  submit();
                }
              },
              autoComplete: "off",
            }}
          />
        )}
      />
    </Box>
  );
}
